import React from 'react'
import Grid from './Grid'
// import {Grid} from '@material-ui/core'
export default function GridContainer(props:any) {
    return (
      <Grid container sm={12} lg={12} xs={12} md={12} style={{"padding":"10px",...props.style}} alignItems="center" className={props.classname}>
        {props.children}
      </Grid>
    )
}
